<template>
  <CCard>
    <CCardHeader>
      <h5>{{ title }}</h5>
      <h3>{{ selectedDirectory.empresa }}</h3>
      <span>{{ selectedDirectory.identificacion }}</span>
    </CCardHeader>
    <CCardBody>
      <CTabs>
            <CTab title="Estado de cuenta" v-if="type !== 'PR'">
              <AccountStatusTab />
            </CTab>
            <CTab title="Ventas" v-if="type === 'CL' || type === 'CP'">
              <CustomerSalesTab />
            </CTab>
            <!-- <CTab title="Entregas Mercancia" v-if="type === 'CL' || type === 'CP'">
              
            </CTab> -->
            <CTab title="Cotizaciones">
              <QuotesCustomerTab />
            </CTab>
            <CTab title="Pedidos" v-if="type === 'CL' || type === 'CP'">
              <OrdersCustomerTab />
            </CTab>
            <!-- <CTab title="Oportunidades">
              
            </CTab> -->
            <CTab title="Seguimientos">
              <CContainer class="mt-4">
                <BusinessTracking :directoryId="selectedDirectory.id_Directorio" />
              </CContainer>
            </CTab>
            <!-- <CTab title="Sucursales"  v-if="type === 'CL' || type === 'CP'">

            </CTab> -->
            <CTab title="Dependencias">
              <ContactsTab />
            </CTab>
            <!-- <CTab title="Precios Venta" v-if="type==='CL' || type==='CP'">

            </CTab>
            <CTab title="Costos Productos" v-if="type==='PR' || type==='CP'">

            </CTab> -->
        </CTabs>
    </CCardBody>
  </CCard>
</template>
<script>
  import BusinessTracking from "@/components/datagrids/BusinessTracking.vue";

  import AccountStatusTab from '@/components/file/DirectoryEmployee/DirectoryEmployeeItemViewTabs/AccountStatusTab.vue'
  import CustomerSalesTab from './DirectoryEmployeeItemViewTabs/CustomerSalesTab.vue'
  import QuotesCustomerTab from "./DirectoryEmployeeItemViewTabs/QuotesCustomerTab.vue";
  import OrdersCustomerTab from "./DirectoryEmployeeItemViewTabs/OrdersCustomerTab.vue";
  import ContactsTab from "../../datagrids/DependenciesDirectory.vue";

  export default {
    data() {
        return {
        }
    },
    components: {
      BusinessTracking,
      AccountStatusTab,
      CustomerSalesTab,
      QuotesCustomerTab,
      OrdersCustomerTab,
      ContactsTab
    },
    methods: {
    },
    computed: {
      selectedDirectory(){
        return this.$store.state.selectedDirectory
      },
      title() {
        if(this.type === 'CL') return 'Cliente'
        if(this.type === 'PR') return 'Proveedor'
        if(this.type === 'CP') return 'Cliente/Proveedor'
        return 'Prospecto'
      },
      type() {
        return this.selectedDirectory.tipo_Directorio
      },
      AccountStatusPath(){
        if(this.type === 'CL') return 'dataGridEstadoCuentaCliente'
        if(this.type === 'PR') return 'dataGridEstadoCuentaProveedor'
        return 'dataGridEstadoCuentaCliente'
      }
    }
  }
</script>
